
/**
 * Created by h3 on 2018-05-14.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";


export class TractorBeamReelAreaView extends ReelAreaView {

    constructor(positions: [number, number][]) {
        super(ResourcesGroupName.MAIN);

        /*
         * graphics polygon for mask
         *
         * graphics.drawPolygon([new PIXI.Point(200, 200),
                      new PIXI.Point(300, 200),
                      new PIXI.Point(600, 200),
                      new PIXI.Point(600, 100),
                      new PIXI.Point(400, 110),
                      new PIXI.Point(200, 100),
                    ]);
         */

    }

    protected onResize(resizeData:IResizeData):void {
        this.x = GameConfig.instance.REEL_AREA_POS_X;
        this.y = (resizeData.orientation === Orientation.LANDSCAPE)? GameConfig.instance.REEL_AREA_POS_Y : TractorBeamGameConfig.instance.REEL_AREA_POS_Y_PORTRAIT;

        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            this.updateReelViewPosition(reelView, reelId);
        });

        this.UpdateReelAreaMask();
    }
}
